import { PlanPurchaseExperienceMode } from '../../types/Plan'

export function deserializePlanPurchaseExperienceModeQueryParam(
  value: string | undefined
): PlanPurchaseExperienceMode | undefined {
  switch (value?.toLowerCase()) {
    case 'changepayment':
    case 'change_payment':
      return PlanPurchaseExperienceMode.CHANGE_PAYMENT
    case 'purchaseaddons':
    case 'purchase_addons':
      return PlanPurchaseExperienceMode.PURCHASE_ADDONS
  }
}
